import React from "react";

export default function About() {
  return (
    <section className="section" id="about">
      <div className="container">
        <div className="about-wrapper">
          <div className="about-card about-card-main">
            <span className="section-label">About</span>
            <h2>About Yaich Translations</h2>
            <p>
              Yaich Translations is a professional English to Arabic translation
              service focused on legal, official, administrative, academic,
              business and personal documents.
            </p>
            <p>
              The website is designed to offer a modern, clear and trustworthy
              experience for clients who need professionally presented
              translations for important matters in the UK and beyond.
            </p>
          </div>

          <div className="about-card">
            <h3>Service Highlights</h3>
            <ul className="about-list">
              <li>English to Arabic translation</li>
              <li>Professional document handling</li>
              <li>Suitable for official and legal use</li>
              <li>Clear and client-friendly communication</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}